<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <promotion-join-report-table></promotion-join-report-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import PromotionJoinReportTable from './PromotionJoinReportTable.vue'

  export default {
    name: 'promotion-join-report',
    components: {PromotionJoinReportTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/report/promotion/promotionJoin/PromotionJoinReport.vue